import React, { useContext, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ConfigContext } from '../../../providers';
import styles from './systemnotification.module.scss';
import { cn } from '../../../helpers';
import { UserIcon } from '../../../assets/images/svg';

export enum SystemNotificationLinkType {
    REMOVE,
}

interface ISystemNotificationProps {
    notificationId: number;
    linkTypes: Array<SystemNotificationLinkType>;
    onRemoveClick?: (notificationId: number) => void;
}

export const SystemNotification: FC<ISystemNotificationProps> = ({
    children,
    linkTypes,
    notificationId,
    onRemoveClick,
}): JSX.Element => {
    const { colors } = useContext(ConfigContext);

    const handleRemoveClick = (): void => onRemoveClick?.(notificationId);

    return (
        <div
            className={cn('d-flex align-items-center mb-1', styles.notification)}
            style={{ backgroundColor: colors.mailItem.hoverBackground }}
        >
            <UserIcon />
            <div className={cn('d-flex align-items-center flex-fill', styles.notifytext)}>
                {children}
                {linkTypes.includes(SystemNotificationLinkType.REMOVE) && (
                    <div className="d-flex col-2 col-sm-3 justify-content-end">
                        <button
                            onClick={handleRemoveClick}
                            className={styles.notifylink}
                            style={{ color: colors.mailItem.titleColor }}
                        >
                            <FormattedMessage id="REMOVE" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
